<template>
  <div>
    <div class="card card--transparent">
      <chart :results="results" />
    </div>
    <slot class="small-top" style="margin-top: 20px"></slot>
    <div class="card card--white small-top">
      <h1>Full Report</h1>
      <div class="section">
        <div v-for="attribute in results" :key="attribute.id" class="small-top">
          <h3>{{attribute.name}} ({{attribute.score}})</h3>
          <div class="description">{{attribute.description}}</div>
        </div>
      </div>
      <!-- <div class="row" v-if="referConsultation">
        <avatar image="" />
        <div>
          <a href="https://calendly.com/habittech/call_with_james">Hey want a <b>FREE</b> consultation
          discover how Habit Technologies can increase your bussiness.</a>
        </div>
      </div> -->
  </div>
  </div>
</template>

<script>
import chart from "./chart";
import avatar from "@/components/userImg";

export default {
  components: { chart, avatar },
  props: ["results", "referConsultation"]
};
</script>

<style lang="less" scoped>
.description {
  line-height: 22px;
  font-weight: 100;
}
</style>
